<template>
  <div class="dates">
    <input-label :text="$t('dates.chosen_by_client.label')" />
    <input-selector v-model="chosen_by_clientSync"
                    :options="chosen_by_clientOptions" />
      <next-transition :visible="is_valid_chose_by_clientSync">
        <input-label :text="dateLabel" />
        <date-range
          v-model="dateSync"
          :range="chosen_by_clientSync !== 1"
          :placeholder-start="datePlaceholderStart"
          :placeholder-end="$t('dates.date.placeholder.end')"
          :disabled-date="disabledDate"
          name="date">
          <template #before-text>
            {{ startLabel }}
          </template>
          <template #between-text>
            {{ $t('dates.date.endThe') }}
          </template>
        </date-range>
      </next-transition>
  </div>
</template>

<script>
import InputSelector from '@/components/utils/InputSelector.vue';
import InputLabel from '@/components/utils/InputLabel.vue';
import DateRange from '@/components/utils/DateRange.vue';
import NextTransition from '@/components/utils/NextTransition.vue';
import { UNKNOWN_DATE, FIX_DATE, FLEXIBLE_DATE } from '@/store/modules/serviceOfferStore';


export default {
  name: 'dates',
  components: {
    NextTransition,
    DateRange,
    InputLabel,
    InputSelector,
  },
  data() {
    return {
      knownDate: null,
      date: {},
    };
  },
  computed: {
    is_valid_chose_by_clientSync() {
      return this.chosen_by_clientSync === UNKNOWN_DATE
        || this.chosen_by_clientSync === FIX_DATE
        || this.chosen_by_clientSync === FLEXIBLE_DATE;
    },
    chosen_by_clientSync: {
      get() {
        return this.$store.getters['serviceOfferStore/dates'][0]?.chosen_by_client;
      },
      set(chosen_by_client) {
        this.$store.commit('serviceOfferStore/SET_DATES', [
          {
            ...this.$store.getters['serviceOfferStore/dates'][0],
            chosen_by_client,
            type: 1,
          },
          {
            ...this.$store.getters['serviceOfferStore/dates'][1],
            chosen_by_client,
            type: 2,
          },
        ], { root: true });
      },
    },
    chosen_by_clientOptions() {
      return [
        {
          label: this.$t('dates.chosen_by_client.options.yes'),
          value: FIX_DATE,
        },
        {
          label: this.$t('dates.chosen_by_client.options.yesFlex'),
          value: FLEXIBLE_DATE,
        },
        {
          label: this.$t('dates.chosen_by_client.options.no'),
          value: UNKNOWN_DATE,
        },
      ];
    },
    dateSync: {
      get() {
        return {
          start: this.$store.getters['serviceOfferStore/dates'][0]?.date_first,
          end: this.$store.getters['serviceOfferStore/dates'][0]?.date_last,
        };
      },
      set(date) {
        this.$store.commit('serviceOfferStore/SET_DATES', [
          {
            ...this.$store.getters['serviceOfferStore/dates'][0],
            date_first: date.start,
            date_last: date.end,
          },
          {
            ...this.$store.getters['serviceOfferStore/dates'][1],
            date_first: date.start,
            date_last: date.end,
          },
        ], { root: true });
      },
    },
    dateLabel() {
      switch (this.chosen_by_clientSync) {
        case UNKNOWN_DATE:
          return this.$t('dates.date.labelPeriodeUnKnown');
        case FIX_DATE:
          return this.$t('dates.date.labelDate');
        default:
          return this.$t('dates.date.labelPeriode');
      }
    },
    startLabel() {
      return this.chosen_by_clientSync === FIX_DATE
        ? this.$t('dates.date.the')
        : this.$t('dates.date.between');
    },
    datePlaceholderStart() {
      return this.chosen_by_clientSync === FIX_DATE
        ? this.$t('dates.date.placeholder.date')
        : this.$t('dates.date.placeholder.start');
    },
  },
  methods: {
    formattingDate(date) {
      const d = new Date(date);
      const day = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();
      const month = d.getMonth() + 1 < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    },
    disabledDate(date) {
      return this.formattingDate(date) <= this.formattingDate(new Date());
    },
  },
};
</script>

<style scoped lang="scss">

.inline-block {
  display: inline-block;
}
::v-deep .el-form-item__label {
  text-align: left;
}

.dates {
  &--form {
    &__title {
      margin-top: 0;
    }
    &__actions {
      text-align: right;
    }
    &__to {
      margin: 0 10px;
    }
    &__daterange {
      margin-top: 10px;
      @include breakpoint(tablet) {
        margin-top: 0;
      }
    }
  }
}
</style>
